export const QUESTION = 'Find Your Mood Balance'

export const OPTION_VALUES = {
  IMPROVE_SLEEP_QUALITY: 'improve_sleep_quality',
  REDUCE_STRESS_OR_ANXIETY: 'reduce_stress_or_anxiety',
  PLAY_RELAXING_GAMES: 'play_relaxing_games',
  FIND_OUT_MORE_ABOUT_MY_MOOD: 'find_out_more_about_my_mood',
  SOMETHING_ELSE: 'something_else',
}
